export interface UnitValueBase {
  value: number;
}
export interface LengthInch extends UnitValueBase {
  unit: "in";
}
export interface LengthCm extends UnitValueBase {
  unit: "cm";
}
export interface LengthMm extends UnitValueBase {
  unit: "mm";
}

export type Length = LengthInch | LengthCm | LengthMm;

export function convertLength(a: Length, to: "in" | "cm" | "mm"): Length {
  if (a.unit === "in" && to === "cm") {
    return {
      value: a.value * 2.54,
      unit: "cm",
    };
  } else if (a.unit === "in" && to === "mm") {
    const lengthCm = convertLength(a, "cm");
    return convertLength(lengthCm, "mm");
  } else if (a.unit === "cm" && to === "in") {
    return {
      value: a.value / 2.54,
      unit: "in",
    };
  } else if (a.unit === "cm" && to === "mm") {
    return {
      value: a.value * 10,
      unit: "mm",
    };
  } else if (a.unit === "mm" && to === "in") {
    const lengthCm = convertLength(a, "cm");
    return convertLength(lengthCm, "in");
  } else if (a.unit === "mm" && to === "cm") {
    return {
      value: a.value / 10,
      unit: "cm",
    };
  } else if (a.unit !== to) {
    console.error("Not implement", a.unit, "to", to);
    return a;
  } else {
    return a;
  }
}

export function addLengths(a: Length, b: Length): Length {
  const convertedLength = convertLength(b, a.unit);
  return {
    value: a.value + convertedLength.value,
    unit: a.unit,
  };
}

export function subLengths(a: Length, b: Length): Length {
  const convertedLength = convertLength(b, a.unit);
  return {
    value: a.value - convertedLength.value,
    unit: a.unit,
  };
}

export function multiplyLength(Length: Length, by: number): Length {
  return {
    value: Length.value * by,
    unit: Length.unit,
  };
}

export function lengthToString(length: Length): string {
  return `${length.value}${length.unit}`;
}
